import React, { FC, PropsWithChildren } from 'react';

import { CheckIconInCircle } from "../CheckIconInCircle";

import styles from './LinearProgressWithTitleAndLabel.module.scss';

export interface ILinearProgressWrapperProps {
    wrapperClassName: string;
}

export const LinearProgressWrapper = ({ wrapperClassName, children }: PropsWithChildren<ILinearProgressWrapperProps>) => (
    <div className={wrapperClassName}>
        {children}
    </div>
);

export interface ILinearProgressLabelProps extends Omit<ILinearProgressTitleAndLabelProps, 'title'> {}

export const LinearProgressLabel = ({ percents, maxPercents, color, labelBg }: ILinearProgressLabelProps) => {

    return (
        <>
            {percents === maxPercents ?
                <CheckIconInCircle checkIconCircleColor={labelBg} checkIconColor={color} />
                :
                <span className={styles.linearProgressTitle}>{percents}%</span>
            }
        </>
    );
};

export interface ILinearProgressTitleAndLabelProps extends ILinearProgressWithTitleAndLabelProps {}

export const LinearProgressTitleAndLabel = ({ title, percents, maxPercents, color, labelBg }: ILinearProgressTitleAndLabelProps) => {

    return (
        <LinearProgressWrapper wrapperClassName={styles.linearProgressTitleAndLabelWrapper}>
            <span className={styles.linearProgressTitle}>{title}</span>
            <LinearProgressLabel percents={percents} maxPercents={maxPercents} color={color} labelBg={labelBg} />
        </LinearProgressWrapper>
    );
};

export interface ILinearProgressProps extends Omit<ILinearProgressWithTitleAndLabelProps, 'title'> {
    maxPercents: number;
}

export const LinearProgress = ({ color, percents, maxPercents }: ILinearProgressProps) => {
    const width = `calc(100% * ${percents / maxPercents})`;

    return (
        <LinearProgressWrapper wrapperClassName={styles.linearProgressWrapper}>
            <div
                className={styles.linearProgress}
                style={{
                    background: color,
                    width
                }}
            />
        </LinearProgressWrapper>
    );
};

export interface ILinearProgressWithTitleAndLabelProps {
    wrapperClass?: string;
    percents: number;
    maxPercents?: number;
    title: string;
    color?: string;
    labelBg?: string;
}

export const LinearProgressWithTitleAndLabel: FC<ILinearProgressWithTitleAndLabelProps>  = ({
                                                               wrapperClass = styles.linearProgressWithTitleAndLabelWrapper,
                                                               percents = 0,
                                                               maxPercents = 100,
                                                               title,
                                                               color = '#EB731A',
                                                               labelBg = '#FFDDBC'
                                                           }) => {

    return (
        <LinearProgressWrapper wrapperClassName={wrapperClass}>
            <LinearProgressTitleAndLabel title={title} percents={percents} maxPercents={maxPercents} color={color} labelBg={labelBg} />
            <LinearProgress color={color} percents={percents} maxPercents={maxPercents} />
        </LinearProgressWrapper>
    )
};
